export interface UmpireApiError {
  title: string;
  detail: string;
  status: string;
  source: {
    pointer: string;
  };
  meta: {
    attribute: string;
    message: string;
    code: string;
  };
}
